import React , { Component, PropTypes } from 'react';
import MyEditor from '../../shared/MyEditor.jsx';
import AppDispatcher , {actions} from '../../shared/dispatcher/AppDispatcher.js';

class AuteurBioBiblio extends Component{
    constructor(props){
        super(props);
        this.state = {'editing' : false};
        this.handleSubmit = this.handleSubmit.bind(this);
        this.startEditing = () => { this.setState({'editing' : true}) };
        this.cancelEditing = () => { this.setState({'editing' : false}) };
    }

    componentDidMount(){
        this.props.fetch(aid);
    }

    handleSubmit(html){
    	this.props.save(aid,html)
    		.then(()=>{
    			AppDispatcher.emit(actions.notifMsg,{'level':'success','title': 'Mise à jour', 
                    'message' : 'La ' + this.props.which + ' a été sauvée, merci !'});
                this.cancelEditing();
    		})
    		.fail((error)=>{
    			AppDispatcher.emit(actions.notifMsg,{'level' : 'error','title': 'Mise à jour', 
                    'message' : error || 'Une erreur imprévue a eu lieu'});
    		});
    }

    render(){
    	let has_data = 0;

        let data_html;
        
        if (this.props.loading){
        	return (<div className="loading"></div>);
        }

        if (! this.props.data){
            data_html = null;
        } else {
            if (this.props.data.html){
            	has_data = 1;
                data_html = {'__html' : this.props.data.html};
            }
        }

        if (this.state.editing){
        	return (
	        	<div className="row">	
            		<div className="col-md-12">
                		<MyEditor initContent={this.props.data.html} cancelEditing={this.cancelEditing} 
                			handleSubmit={this.handleSubmit} />
                	</div>
                </div>
        	)
        }

        if (has_data){
            let txt = this.props.data.createdby ?  'Créée par ' + this.props.data.createdby  + '.' : '' ;
            if (this.props.data.lastupdby){
                txt += ' Mise à jour par ' + this.props.data.lastupdby + ' le ' + this.props.data.lastupd + '.';
            }

        	return (
                <div>
        		<div className="row">
	                <div className="col-md-12" style={{marginTop: 10, marginBottom: 10}}>
	                   	<div className="panel panel-default">
                        <div className="panel panel-body">
                            <div className="well well-sm">{txt}</div>

    	                    <div dangerouslySetInnerHTML={data_html}></div>
                        </div>
	                   </div>
                    </div>
                </div>
                {loginok==1 && (
                    <div className="row">
                        <div className="col-sm-12">
                            <button style={{paddingLeft: 0}} className="btn btn-link" onClick={this.startEditing}>Modifier</button>
                        </div>
                    </div>
                    )
                }
                </div>
	        )
	    }
	    return (
	    	<div className="row">
	    		<div className="col-md-12">
	    			<p>
	    			Pas encore de {this.props.which}, 
                    {this.props.loginok == 1 && (
	    			    <button className="btn btn-link" onClick={this.startEditing}>Cliquez pour en créer une</button>
                    )}
                    { this.props.loginok == 0 && (
                        <span> Connectez vous ou inscrivez vous pour en créér une</span>
                    )}
	    			</p>
	    		</div>
	    	</div> 
	    )
    }
}

AuteurBioBiblio.propTypes = {
    'which': PropTypes.string.isRequired, // biographie or bibliographie
    'data' : PropTypes.shape({
        'html': PropTypes.string,
        'uid' : PropTypes.string,
        'closed' : PropTypes.number,
        'lastupd' : PropTypes.string,
        'lastupdby' : PropTypes.string,
        'hidden' : PropTypes.number
    }),
    'loading': PropTypes.bool.isRequired,
    'processing': PropTypes.bool.isRequired,
    'error': PropTypes.string,
    'loginok' : PropTypes.number.isRequired
}

export default AuteurBioBiblio


// WEBPACK FOOTER //
// ./auteur/biobiblio/AuteurBioBiblio.jsx